export default __webpack_public_path__ + "static/media/Dagger of Envy's Fury.245b9e71.jpg";